import graphQLAdapter from "@/adapters/graphQL.adapter.js";

/**
 * VariantCharacter Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getFamilyEmblems = getFamilyEmblems.bind(this);
  }

  async find (options) {
    await this.adapter.init();

    // 「手書き」または「SK書体」を選択した場合、該当する家紋画像が用意されていないため
    // 「機械書(合掌体)」の家紋を表示するようにする（異体字と同じ仕様）
    // 「機械書手彫風書体」を選択した場合は「手彫り風書体」の家紋を表示する
    if (
      options.q &&
      (options.q.font === "手書き" || options.q.font === "SK書体")
    ) {
      options.q.font = "合掌体";
    } else if (options.q && options.q.font === "機械書手彫風書体") {
      options.q.font = "手彫り風書体";
    }

    const res = await this.getFamilyEmblems(options);
    if (res.data) {
      return res.data.familyEmblemTypes;
    }
    return res.errors;
  }
}

function getFamilyEmblems (options = {}) {
  const query = `
    query ($q: FamilyEmblemTypeFilterConditions!) {
      familyEmblemTypes(q: $q) {
        id
        font
        name
        nameKana
        familyEmblems {
          id
          name
          imageUrl
          imageUrlForTablet
          inputCode
        }
      }
    }
  `;
  return this.adapter.query(query, options);
}
